import { jsx as _jsx } from "react/jsx-runtime";
import { PlaceholderWrapper } from 'helpers/SitecoreWrappers/PlaceholderWrapper/PlaceholderWrapper';
import { getTestProps } from 'lib/testing/utils';
export const Default = (props)=>{
    const { rendering } = props;
    const phKey = `custom-search-main`;
    return /*#__PURE__*/ _jsx("div", {
        className: "w-full flex flex-col",
        ...getTestProps(`component-search-main-${rendering?.uid}`),
        children: /*#__PURE__*/ _jsx(PlaceholderWrapper, {
            name: phKey,
            rendering: rendering
        })
    });
};
